module.exports = __webpack_public_path__ + "static/img/four.5ca45e8a.png";